import React from 'react';
import { Arbitrator } from '../../../api/responses';
import DoteDivider from '../../common/DoteDivider';
import { CaseLinksContainer, Description, Item, Name } from './styles';

type TArbitratorsChain = {
  chief: Arbitrator;
  other: Arbitrator[];
  lang?: string;
};

const ArbitratorsChain = ({ chief, other, lang = 'ru' }: TArbitratorsChain) => {
  const allArbitrators = [
    ...(chief
      ? [
          {
            ...chief,
            role: `${lang === 'ru' ? 'Главный арбитр' : 'Chief Arbitrator'}`,
          },
        ]
      : []),
    ...(other
      ? other.map((arb) => ({
          ...arb,
          role: `${lang === 'ru' ? 'Арбитр' : 'Arbitrator'}`,
        }))
      : []),
  ];

  return (
    <CaseLinksContainer>
      {allArbitrators.map((arbitrator, index) => (
        <React.Fragment key={arbitrator.id || index}>
          <Item>
            <Name>{`${arbitrator.last_name} ${arbitrator.first_name}`}</Name>
            <Description>{arbitrator.role}</Description>
          </Item>
          {index < allArbitrators.length - 1 && <DoteDivider />}
        </React.Fragment>
      ))}
    </CaseLinksContainer>
  );
};

export default ArbitratorsChain;
